import React from 'react'

import { TSegmentConrolCommon } from 'cng-common/components/segmentedControl/models'
import { RowButtons } from 'partner360/components/rowButtons/RowButtons'

export interface IPartnerTypeButtonsProps {
  buttonCurrType: string
  setButtonCurrType: (newValue: string) => void
  buttonTypes: string[]
  className?: string
  disabled?: boolean
  translationKey?: string
  size?: TSegmentConrolCommon['size']
  background?: TSegmentConrolCommon['backgroudn']
}

export const PartnerTypeButtons = ({
  buttonTypes,
  buttonCurrType,
  setButtonCurrType,
  size,
  disabled,
  translationKey: translationPrefix,
  background,
}: IPartnerTypeButtonsProps) => {
  const getTranslationKey = (type: string) =>
    `${translationPrefix || 'jbp-partner-type'}-${type.trim().replace(/\s/g, '').toLowerCase()}`

  return (
    <RowButtons
      value={buttonCurrType}
      options={buttonTypes}
      generateTranslationKey={getTranslationKey}
      onOptionClick={setButtonCurrType}
      isDisabled={disabled}
      size={size}
      background={background}
    />
  )
}
